<div class="container">
  <div class="row">
    <div class="col-md-7 content">
    <lib-transfers-table
      (sendPageView)="onSendPageView()"
      [entityType]="entityType"
      [entityId]="leagueService.getCurrentLeagueId()"
      [pageSize]="16">
    </lib-transfers-table>
    </div>
    <div class="col-md-5 sidebar" *ngIf="layoutService.displayProfileHeader">
      <div class="row">
        <div class="col-12" *ngIf="league != null">
          <lib-league-table [smallTable]="true" [showLeagueName]="false" [league]="league"></lib-league-table>
        </div>
        <lib-ad class="col-12 mb-2"></lib-ad>
        <div class="col-12" *ngIf="league">
          <app-current-games [leagueId]="league.id" [readableId]="league.readable_id"></app-current-games>
        </div>
      </div>
    </div>
  </div>
</div>
